import { ColumnDef } from "./types";

export const DEFAULT_COLUMNS_BY_NAME: Record<string, ColumnDef[]> = {
  region: [
    { key: "Name", label: "Name", required: true },
    { key: "Type", label: "Type", required: false },
    { key: "Status", label: "Status", required: true },
    { key: "Manager", label: "Manager", required: false },
    { key: "Created Date", label: "Created Date", required: false },
  ],
  country: [
    { key: "Name", label: "Name", required: true },
    { key: "Type", label: "Type", required: false },
    { key: "Status", label: "Status", required: true },
    { key: "Manager", label: "Manager", required: false },
    { key: "Created Date", label: "Created Date", required: false },
    { key: "Region", label: "Region", required: true },
  ],
  state: [
    { key: "Name", label: "Name", required: true },
    { key: "Type", label: "Type", required: false },
    { key: "Status", label: "Status", required: true },
    { key: "Manager", label: "Manager", required: false },
    { key: "Created Date", label: "Created Date", required: false },
    { key: "Country", label: "Country", required: true },
  ],
  county: [
    { key: "Name", label: "Name", required: true },
    { key: "Type", label: "Type", required: false },
    { key: "Status", label: "Status", required: true },
    { key: "Manager", label: "Manager", required: false },
    { key: "Created Date", label: "Created Date", required: false },
    { key: "State", label: "State", required: true },
  ],
  city_county: [
    { key: "Name", label: "Name", required: true },
    { key: "Type", label: "Type", required: false },
    { key: "Status", label: "Status", required: true },
    { key: "Manager", label: "Manager", required: false },
    { key: "Created Date", label: "Created Date", required: false },
    { key: "State", label: "State", required: true },
  ],
  zone: [
    { key: "Name", label: "Name", required: true },
    { key: "Type", label: "Type", required: false },
    { key: "Status", label: "Status", required: true },
    { key: "Manager", label: "Manager", required: false },
    { key: "Created Date", label: "Created Date", required: false },
    { key: "Region", label: "Region", required: true },
  ],
  division: [
    { key: "Name", label: "Name", required: true },
    { key: "Type", label: "Type", required: false },
    { key: "Status", label: "Status", required: true },
    { key: "Manager", label: "Manager", required: false },
    { key: "Created Date", label: "Created Date", required: false },
    { key: "Zone", label: "Zone", required: true },
  ],
  area: [
    { key: "Name", label: "Name", required: true },
    { key: "Type", label: "Type", required: false },
    { key: "Status", label: "Status", required: true },
    { key: "Manager", label: "Manager", required: false },
    { key: "Created Date", label: "Created Date", required: false },
    { key: "Sub-Section", label: "Sub-Section", required: true },
  ],
  sub_area: [
    { key: "Name", label: "Name", required: true },
    { key: "Type", label: "Type", required: false },
    { key: "Status", label: "Status", required: true },
    { key: "Manager", label: "Manager", required: false },
    { key: "Created Date", label: "Created Date", required: false },
    { key: "Area", label: "Area", required: true },
  ],
  premise: [
    { key: "Name", label: "Name", required: true },
    { key: "Type", label: "Type", required: false },
    { key: "Status", label: "Status", required: true },
    { key: "Manager", label: "Manager", required: false },
    { key: "Created Date", label: "Created Date", required: false },
    { key: "Sub-Area", label: "Sub-Area", required: true },
    { key: "Address", label: "Address", required: false },
    { key: "Total Units", label: "Total Units", required: false },
    { key: "Location", label: "Location", required: false },
  ],
  unit: [
    { key: "Name", label: "Name", required: true },
    { key: "Type", label: "Type", required: false },
    { key: "Status", label: "Status", required: true },
    { key: "Manager", label: "Manager", required: false },
    { key: "Created Date", label: "Created Date", required: false },
    { key: "Premises", label: "Premises", required: true },
    { key: "Occupancy", label: "Occupancy", required: false },
    { key: "Ownership", label: "Ownership", required: false },
    { key: "Location Type", label: "Location Type", required: false },
  ],
};

export const getColumnsForEntityType = (entityLabel: string): ColumnDef[] => {
  if (!entityLabel) return DEFAULT_COLUMNS_BY_NAME.region;

  const normalizedKey = entityLabel.toLowerCase().replace(/[\s\/-]/g, "_");

  if (DEFAULT_COLUMNS_BY_NAME[normalizedKey]) {
    return DEFAULT_COLUMNS_BY_NAME[normalizedKey];
  }

  // Check aliases
  if (normalizedKey.includes("premise") || normalizedKey.includes("premises")) {
    return DEFAULT_COLUMNS_BY_NAME.premise;
  }
  if (normalizedKey.includes("sub_area") || normalizedKey.includes("subarea")) {
    return DEFAULT_COLUMNS_BY_NAME.sub_area;
  }
  if (normalizedKey.includes("city") || normalizedKey.includes("county")) {
    return DEFAULT_COLUMNS_BY_NAME.county;
  }

  const foundKey = Object.keys(DEFAULT_COLUMNS_BY_NAME).find((k) =>
    normalizedKey.includes(k) || k.includes(normalizedKey)
  );

  if (foundKey) {
    return DEFAULT_COLUMNS_BY_NAME[foundKey];
  }

  return [
    { key: "Name", label: "Name", required: true },
    { key: "Type", label: "Type", required: false },
    { key: "Status", label: "Status", required: true },
    { key: "Manager", label: "Manager", required: false },
    { key: "Created Date", label: "Created Date", required: false },
  ];
};
